skrilla.controller('createPromotionDefinitionCtrl', function ($scope, searchService, srefService, currencyService, promotionService, modalService, cacheService) {
    $scope.validate = {}
    $scope.btagPromotion = cacheService.getObjectOrElse("promotionPurpose", undefined) === 'BTAG_REFERRAL'

    $scope.promotion = {
        currency: "AUD",
        promotionPurpose: $scope.btagPromotion ? "BTAG_REFERRAL" : "DEPOSIT_BONUS",
        ownerAmount: 0,
        claimerAmount: 0,
        maxCodeClaimsPerUser: 1
    }
    $scope.currencies = currencyService.getCurrencies();
    $scope.purposes = Object.keys(promotionService.getPurposes());

    $scope.save = function() {
        if(promotionService.validatePromotion($scope.promotion, $scope.validate)) {
            modalService.confirm("Are you sure you'd like to create this promotion definition?", function () {
                const request = {
                    ...$scope.promotion,
                    ownerAmount: currencyService.multiply($scope.promotion.ownerAmount, $scope.promotion.currency),
                    claimerAmount: currencyService.multiply($scope.promotion.claimerAmount, $scope.promotion.currency)
                }
                searchService.post("promotions/definitions", request, "Promotion Successfully created").then(function (response) {
                    modalService.dismissAll();
                    srefService.go("promotionDetails", {id: response.data});
                }, function (response) {
                    $scope.promotion.ownerAmount = currencyService.divide($scope.promotion.ownerAmount, $scope.promotion.currency)
                    $scope.promotion.claimerAmount = currencyService.divide($scope.promotion.claimerAmount, $scope.promotion.currency)
                })
            });
        }
    }

});
